import { useEffect, useState } from "react";
import axios from "axios";
import { Authorization } from "../../Context/Authorization";

const ViewBeatCode = ({ rangeId, rangeName }) => {
  const Api = process.env.REACT_APP_API;
  const [beats, setBeats]     = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!rangeId) { setBeats([]); return; }
    fetchBeats(rangeId);
  }, [rangeId]);

  const fetchBeats = async (id) => {
    setLoading(true);
    try {
      const res = await axios.get(`${Api}/api/beat/by-range/${id}`, Authorization());
      setBeats(res.data.beats || []);
    } catch {
      setBeats([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      background: "#fff",
      borderRadius: 14,
      border: "1px solid #E2E8F0",
      boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      overflow: "hidden",
    }}>
      {/* Card header */}
      <div style={{
        padding: "14px 20px",
        borderBottom: "1px solid #E2E8F0",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <i className="mdi mdi-format-list-bulleted" style={{ color: "#2E7D32", fontSize: 18 }} />
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#2D3748" }}>
              {rangeName ? `Beats — ${rangeName} Range` : "Beats"}
            </div>
            <div style={{ fontSize: 11, color: "#A0AEC0" }}>
              {loading ? "Loading…" : `${beats.length} beat${beats.length !== 1 ? "s" : ""} found`}
            </div>
          </div>
        </div>
        {beats.length > 0 && (
          <span style={{
            background: "#E8F5E9", color: "#1B5E20",
            fontSize: 11, fontWeight: 700, borderRadius: 20,
            padding: "3px 10px",
          }}>
            {beats.length} Beats
          </span>
        )}
      </div>

      {/* Body */}
      <div style={{ padding: rangeId ? 0 : 24 }}>
        {!rangeId ? (
          <div style={{ textAlign: "center", padding: "40px 24px", color: "#A0AEC0" }}>
            <i className="mdi mdi-map-marker-off-outline" style={{ fontSize: 40, display: "block", marginBottom: 10 }} />
            <div style={{ fontSize: 13, fontWeight: 600 }}>Select a range to view beats</div>
            <div style={{ fontSize: 12, marginTop: 4 }}>Choose a range in the form above</div>
          </div>
        ) : loading ? (
          <div style={{ textAlign: "center", padding: "40px 24px", color: "#A0AEC0" }}>
            <i className="mdi mdi-loading mdi-spin" style={{ fontSize: 32, display: "block", marginBottom: 10 }} />
            <div style={{ fontSize: 13 }}>Loading beats…</div>
          </div>
        ) : beats.length === 0 ? (
          <div style={{ textAlign: "center", padding: "40px 24px", color: "#A0AEC0" }}>
            <i className="mdi mdi-map-marker-question-outline" style={{ fontSize: 40, display: "block", marginBottom: 10 }} />
            <div style={{ fontSize: 13, fontWeight: 600 }}>No beats found</div>
            <div style={{ fontSize: 12, marginTop: 4 }}>Create a beat using the form above</div>
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#F8FAFC" }}>
                  {["#", "Beat Name", "Beat Code"].map((h, i) => (
                    <th key={h} style={{
                      padding: "10px 16px", textAlign: i === 0 ? "center" : "left",
                      fontSize: 11, fontWeight: 700, color: "#718096",
                      textTransform: "uppercase", letterSpacing: 0.6,
                      borderBottom: "1px solid #E2E8F0",
                      width: i === 0 ? 56 : "auto",
                    }}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {beats
                  .sort((a, b) => a.beatName.localeCompare(b.beatName))
                  .map((beat, index) => (
                    <tr
                      key={beat._id}
                      style={{ borderBottom: "1px solid #F0F4F7", transition: "background 0.1s" }}
                      onMouseEnter={(e) => e.currentTarget.style.background = "#F8FAFC"}
                      onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                    >
                      <td style={{ padding: "11px 16px", textAlign: "center", fontSize: 12, color: "#A0AEC0", fontWeight: 600 }}>
                        {index + 1}
                      </td>
                      <td style={{ padding: "11px 16px", fontSize: 13, color: "#2D3748", fontWeight: 500 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <span style={{
                            width: 7, height: 7, borderRadius: "50%",
                            background: "#2E7D32", flexShrink: 0,
                          }} />
                          {beat.beatName}
                        </div>
                      </td>
                      <td style={{ padding: "11px 16px" }}>
                        <span style={{
                          display: "inline-block",
                          background: "#F0FFF4", color: "#276749",
                          border: "1px solid #C6F6D5",
                          borderRadius: 6, padding: "2px 10px",
                          fontSize: 12, fontWeight: 700, letterSpacing: 0.5,
                          fontFamily: "monospace",
                        }}>
                          {beat.beatCode}
                        </span>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewBeatCode;
